import { Component, OnInit } from '@angular/core';
import { URL_ROOT_PATH, URL_AUTH_GOOGLE, CLIENT_ID, CONTEXT_PATH} from 'src/assets/js/global';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent implements OnInit {
  contextPath = CONTEXT_PATH;
  constructor() { }

  ngOnInit(): void {
    this.contextPath = CONTEXT_PATH;
    $(document).ready (function() {

    });
  }
  login() {
    $(this).attr('href', '/signin');
  }
  registration() {
    alert(2);
  }
}
